import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { RecurranceType, WorkflowStates } from 'src/app/job/constants/job-detail.constants';
import { TargetTradeOption } from 'src/app/job/constants/job-post/job-post.enums';
import { AdvancedSeachFilteredJobsResult } from 'src/app/job/models/dashboard/advanced-search-filtered-jobs-result.model';
import { JobDetailService } from 'src/app/job/services/job-detail/job-detail-service';
import { AdvancedSearch } from 'src/app/shared/models/advanced-search.model';

@Component({
  selector: 'app-advanced-filtered-jobs-display',
  templateUrl: './advanced-search-filtered-jobs-display.component.html',
  styleUrls: ['./advanced-search-filtered-jobs-display.component.scss'],
})
export class AdvancedSearchFilteredJobsDisplayComponent implements OnInit {
  @Output() clickRow = new EventEmitter();
  @Input() jobList: AdvancedSeachFilteredJobsResult[];
  @Input() isApply: boolean;
  workflowStatesEnum: typeof WorkflowStates = WorkflowStates;
  targetTradeOptionEnum: typeof TargetTradeOption = TargetTradeOption;
  isMatMenuOpen: boolean;
  constructor(private jobDetailService: JobDetailService) { }

  ngOnInit(): void { }
   
  rowClicked(row) {
    this.clickRow.emit(row);
  }

  ngAfterViewInit() {
    const advanceSearch = AdvancedSearch.getInstance();
    if (advanceSearch.scrolledTop != 0) {
      const bodyContainer = document.querySelector('.page-content-container');
      bodyContainer.scrollTo({
        top: advanceSearch.scrolledTop,
        behavior: 'smooth',
      });
    }
  }

  getJobDueDate(job: AdvancedSeachFilteredJobsResult) {
    if (job.isRecurrenceParentJob && this.filterRecurrenceTypeForRecurrenceEndDateVisibility(job.jobRecurrenceType)) { // means parent recurrance & ticket covered only for specific types of recurrences 
      if (job.isEnabledUnlimitedRecurrence) return "Unlimited";
      else return job.jobRecurrenceEndDate;
    } else return job.dueDate;
  }

  getJobDueDateDescription(job: AdvancedSeachFilteredJobsResult) {
    if (job.isRecurrenceParentJob && this.filterRecurrenceTypeForRecurrenceEndDateVisibility(job.jobRecurrenceType)) { // means parent recurrance & ticket covered only for specific types of recurrences 
      return "Last recurrence";
    } else return "Deadline";
  }

  filterRecurrenceTypeForRecurrenceEndDateVisibility(jobRecurrencyType: RecurranceType) {
    return this.jobDetailService.filterRecurrenceTypeForRecurrenceEndDateVisibility(jobRecurrencyType);
  }

  splitAssignedPM(assignedPM: string): string[] {
    return assignedPM.split(',');
  }

  showAssignSP(job:any){
    return ((job.tradeOption !== this.targetTradeOptionEnum.QuoteRequest && job.tradeOption !== this.targetTradeOptionEnum.OnDemand)
    || job.workflowStatusId === this.workflowStatesEnum.JobQuoteAccepted);
  }
  showInvitedSP(job:any){
    return ((job.tradeOption === this.targetTradeOptionEnum.QuoteRequest || job.tradeOption === this.targetTradeOptionEnum.OnDemand)
     && job.workflowStatusId !== this.workflowStatesEnum.JobQuoteAccepted);
  }
}
